import { Conjunction, Disjunction } from "../../model/ComplexCondition";

function conjunctionTransitionsForKeyConditions(firstCondition, secondCondition) {
  const operands = [firstCondition, secondCondition];
  const parent = null;
  return new Conjunction({ operands }, parent);
}

export function disjunctionTransitionsForKeyConditions(firstCondition, secondCondition) {
  const operands = [firstCondition, secondCondition];
  const parent = null;
  return new Disjunction({ operands }, parent);
}

export function nodeAdditionForKeyCondition(keyConditionNode, newNode) {
  if (keyConditionNode === null) {
    keyConditionNode = newNode;
  } else if (keyConditionNode.isSingleOperand() === true) {
    keyConditionNode = conjunctionTransitionsForKeyConditions(keyConditionNode, newNode);
  } else {
    let keyConditionOperands = keyConditionNode.getOperands();
    keyConditionOperands.push(newNode);
    newNode.parent = keyConditionNode;
  }
  return keyConditionNode;
}

export function findRelatedSimpleCoditionInKeyCondition(keyCondition, attributeName) {
  function isRelatedNode(node) {
    if (node.getAttributeName() === attributeName) {
      return true;
    } else {
      return false;
    }
  }

  if (keyCondition.isSingleOperand() === true) {
    if (isRelatedNode(keyCondition)) {
      return keyCondition;
    }
  } else {
    const operands = keyCondition.getOperands();
    for (let count = 0; count < operands.length; count++) {
      const operand = operands[count];
      if (isRelatedNode(operand)) {
        return operand;
      }
    }
  }
  return null;
}

export function nodeDeletionForKeyCondition(keyConditionNode, nodeToBeDeleted) {
  if (keyConditionNode.isSingleOperand() === true && keyConditionNode === nodeToBeDeleted) {
    nodeToBeDeleted = null;
    keyConditionNode = null;
  } else {
    const operands = keyConditionNode.getOperands();
    const nodeToBeDeletedIndex = operands.indexOf(nodeToBeDeleted);
    operands.splice(nodeToBeDeletedIndex, 1);
    nodeToBeDeleted = null;
  }
  const keyConditionOperands = keyConditionNode?.getOperands();
  if (keyConditionOperands?.length === 1) {
    const onlyChild = keyConditionOperands[0];
    onlyChild.parent = null;
    keyConditionNode = onlyChild;
  }
  return keyConditionNode;
}

export function nodeReplaceForKeyCondition(keyConditionNode, nodeToBeReplaced, newNode) {
  return nodeAdditionForKeyCondition(nodeDeletionForKeyCondition(keyConditionNode,nodeToBeReplaced),newNode)
}
